import { statusColors, statusLabels, type CampaignStatus } from '@/lib/mockData';
import { cn } from '@/lib/utils';

export const StatusBadge = ({ status }: { status: CampaignStatus }) => (
  <span
    className={cn(
      'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold',
      statusColors[status]
    )}
  >
    <span className="size-1.5 rounded-full bg-current" />
    {statusLabels[status]}
  </span>
);
